<template>
  <div>
    <div class="py-5">
      <p
        class="text-black font-medium lg:text-3xl md:text-3xl sm-fsize20 lg:pb-6 md:pb-5 pb-2 w-full"
      >
        About the course
      </p>

      <div v-for="(item, index) in course" :key="index">
        <p class="fsize16 sm-fsize14">
          <!-- Become a Python Programmer and learn one of employer's most requested
          skills of 2021! -->
          {{ item.coursefor.toString() }}
        </p>

        <!-- <p class="font-normal text-lg pt-2" v-html="item.content.toString()">
          {{ item.content.toString() }}
          This is the most comprehensive, yet straight-forward, course for the
          Python programming language! Whether you have never programmed before,
          already know basic syntax, or want to learn about the advanced
          features of Python, this course is for you! In this course we will
          teach you Python 3.
        </p> -->

        <!-- <p class="font-normal text-lg pt-2">
          With over 100 lectures and more than 21 hours of video this
          comprehensive course leaves no stone unturned! This course includes
          quizzes, tests, coding exercises and homework assignments as well as 3
          major projects to create a Python project portfolio!
        </p> -->
        <!-- <p class="font-normal text-lg pt-2">
          Learn how to use Python for real-world tasks, such as working with PDF
          Files, sending emails, reading Excel files, Scraping websites for
          informations, working with image files, and much more!
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      course: [],
    };
  },

  methods: {
    a() {
      this.course.push(this.selectedCourseHome);

      // // console.log(this.selectedCourseHome);
      // console.log(this.course.content);
    },
  },
  mounted() {
    this.a();
  },
  computed: {
    ...mapState("eLearning", ["selectedCourseHome"]),
  },
};
</script>

<style>
ul.bullet {
  list-style-type: square;
}
</style>
